import { PulseLoader, ScaleLoader } from "react-spinners";
import MonBouton from "./design-system/buttons/MonBouton";
import { IoShareSocialOutline } from "react-icons/io5";


export const ActionButtons = ({
    livraison,
    user,
    clientId,
    editingDeliveryId,
    isLoadingInvalidatedDelivery,
    isLoadingRejetDelivery,
    handleValidatedDelivary,
    handleInvalidatedDelivary,
    setOpenInput,
    openInput,
    setEditingDeliveryId,
    handleApprouveDelivary,
    handleShareDelivary,
    // isLoadingShareDelivery
}) => {
    // Détermine si l'utilisateur peut valider/rejeter une livraison
    const canValidateOrReject = () => {
        // Pour les coachs ou assistants coach
        const isCoachOrAssistant = user?.statut === "coach" || user?.statut === "coach-assistant";

        // Pour les clients: il faut qu'ils soient responsables du projet
        const isClientAndProjectOwner = user?.statut === "client" && user?.porteur_projet?.id === clientId;

        // La livraison est en attente
        const isPending = (livraison?.validation === "EN_ATTENTE" || livraison?.validation === "APPROUVE") 

        // L'utilisateur n'est pas celui qui a créé la livraison
        const isNotCreator = user?.id !== livraison?.coach_id && user?.id !== livraison?.bakeliste_id;

        return (isCoachOrAssistant || isClientAndProjectOwner) && isPending && isNotCreator;
    };

    // Détermine si on affiche les boutons d'édition
    const isEditing = editingDeliveryId === livraison?.id;
    const optionShare = (user?.statut === "coach" || user?.statut === "coach-assistant") && livraison?.validation === "APPROUVE" && !livraison?.partager

    if (canValidateOrReject()) {
        return (
            <div className="flex gap-2 justify-end font-inter font-semibold text-sm w-[97%]">
                <MonBouton
                    children={"Rejeter"}
                    couleurFond={"bg-red text-white"}
                    bordure={` flex w-[30%] max-lg:w-2/4 justify-center border outline-none bg-gray-200 text-blk font-inter rounded-full py-1`}
                    action={() => setOpenInput(!openInput)}
                    type={"button"}
                />
                <MonBouton
                    children={livraison?.livraisonFinale && !livraison?.coach_id ? "Approuver" : "Valider"}
                    couleurFond={livraison?.livraisonFinale && !livraison?.coach_id  ? "bg-sky-600/70 text-white" : "bg-orange text-white"}
                    bordure={` flex w-[30%] max-lg:w-2/4 justify-center border outline-none bg-gray-200 text-blk font-inter rounded-full py-1`}
                    action={() => livraison?.livraisonFinale && !livraison?.coach_id ? handleApprouveDelivary(livraison) : handleValidatedDelivary(livraison)}
                    type={"button"}
                    iconRight={isLoadingInvalidatedDelivery && <PulseLoader size={5} color='white' />}
                />
            </div>
        );
    } else if (isEditing) {
        return (
            <div className="flex gap-2">
                <MonBouton
                    children={"Enrégister"}
                    couleurFond={"bg-vr text-white"}
                    bordure={`px-2 flex max-w-max justify-start border outline-none bg-blue-400 text-blk font-inter text-xs rounded py-1`}
                    action={() => handleInvalidatedDelivary(livraison)}
                    type={"button"}
                    iconRight={isLoadingRejetDelivery && <PulseLoader size={3} color="#fff" />}
                />
                <MonBouton
                    children={"Annuler"}
                    couleurFond={"bg-grys/60"}
                    bordure={`px-2 flex max-w-max justify-start border outline-none bg-gray-200 text-blk font-inter text-xs rounded py-1`}
                    action={() => setEditingDeliveryId(null)}
                    type={"button"}
                />
            </div>
        );
    }
    else if (optionShare) {
        return (<div className="flex gap-2 justify-end font-inter font-semibold text-sm w-[97%]">
            <MonBouton
                children={"Partager"}
                couleurFond={"bg-orange text-white"}
                bordure={` flex w-[35%] max-lg:w-2/4 justify-center border outline-none bg-gray-200 text-blk font-inter rounded-full py-1 tooltip`}
                action={() => handleShareDelivary(livraison)}
                data-tip="Partager le livrable avec le client"
                type={"button"}
                icone={<IoShareSocialOutline />}
                iconRight={isLoadingInvalidatedDelivery && <ScaleLoader size={2} color="#fff" />}
            />
        </div>)
    }

    return null;
};